<template>
  <main class="pt-14 md:pt-0">
    <SectionDefault>
      <div class="container md:pt-36 pb-5 flex md:items-start print:!pl-0">
        <div class="flex flex-col relative">
          <div class="grid md:grid-cols-12">
            <div class="hidden md:block pr-3 md:col-span-2">
              <AtomBreadcrumb
                v-for="breadcrumb in hero.breadcrumbs"
                :key="breadcrumb.key"
                :to="breadcrumb.to"
                :content="breadcrumb.title"
              />
            </div>
            <div class="md:col-span-10 gap-5 flex flex-col">
              <div v-if="page.tags?.length != 0" class="flex flex-wrap z-10 items-center gap-2">
                <AtomTag
                  v-for="tag in page.tags"
                  :key="tag.id"
                  tag="span"
                  class="bg-white !shadow-none border-[1px] relative before:absolute before:-inset-1 before:translate-y-full before:duration-300 before:bg-gray-100 group-hover:text-white group-hover:before:translate-y-0"
                  :content="tag.title"
                />
              </div>
              <h2 class="md:text-xl text-[22px]">{{ hero.title }}</h2>
              <div class="flex text-xs text-gray-400 justify-between gap-4">
                <p>
                  {{ new Date(page.date).toLocaleDateString('ru-RU', { dateStyle: 'long' }).slice(0, -3) }}
                </p>
                <p>{{ page.time_to_read }}</p>
              </div>

              <AtomImage class="w-full max-h-[584px] object-cover" :strapi-image-object="hero.strapiImageObject" />
            </div>
          </div>
        </div>
      </div>
      <Builder
        class="[&_.typo-text_h2]:mt-11 [&_.typo-text_h2]:md:mb-5 [&_.typo-text_h2]:mb-3 [&_.typo-text_h2]:text-[19px] [&_.typo-text_h2]:md:text-[30px] [&_img]:max-h-[584px] [&_img]:object-cover"
        :blocks="blocks"
        :context="{ insights: page.relatedArticles }"
      />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../../components/builder/Builder'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import AtomBreadcrumb from '../../components/atoms/layouts/AtomBreadcrumb'
import AtomImage from '../../components/atoms/AtomImage.vue'
import AtomTag from '../../components/atoms/AtomTag.vue'

const mixinPageBuilder = pageBuilder({
  pageUrl: context => `article/${context.params.slug}`,
  prependPage: false,
})

export default {
  name: 'InsightDetails',
  components: {
    SectionDefault,
    AtomBreadcrumb,
    Builder,
    AtomImage,
    AtomTag,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: this.page.title,
            author: 'Encore Fitness',
            datePublished: this.page.publishedAt,
            dateModified: this.page.updatedAt || this.page.publishedAt,
            image: this.page.image?.url ? `https://encorefitness.ru${this.page.image.url}` : null,
            articleBody: this.articleContent,
          },
        },
      ],
    }
  },
  computed: {
    hero() {
      return { title: this.page.title, strapiImageObject: this.page.image, breadcrumbs: this.$breadcrumbs.insights() }
    },
    articleContent() {
      return (
        this.page.blocks
          ?.map(block => block.title || block.description || '')
          .join(' ')
          .trim() || this.page.title
      )
    },
  },
}
</script>

<style scoped>
/* .blog-wrapper > *:not(.typo-insights-block, .typo-form-learn-more) {
  grid-column-start: ;
} */
</style>
